"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInitialAddressOfStoreValues = exports.setAddressOfStoreValuesToFormDataOfRegisterForm = exports.default = void 0;
var _core = require("@material-ui/core");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactRedux = require("react-redux");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _config = require("../config");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var addressOfStoreFieldsNames = ['address-address_01', 'address-city', 'address-country', 'address-state', 'address-latitude', 'address-longitude', 'address-zipcode'];
var setAddressOfStoreValuesToFormDataOfRegisterForm = function setAddressOfStoreValuesToFormDataOfRegisterForm(values) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$exclude = _ref.exclude,
    exclude = _ref$exclude === void 0 ? [] : _ref$exclude;
  return _lodash.default.pick(values, _lodash.default.filter(addressOfStoreFieldsNames, function (item) {
    return !_lodash.default.includes(exclude, item);
  }));
};
exports.setAddressOfStoreValuesToFormDataOfRegisterForm = setAddressOfStoreValuesToFormDataOfRegisterForm;
var setInitialAddressOfStoreValues = function setInitialAddressOfStoreValues() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$exclude = _ref2.exclude,
    exclude = _ref2$exclude === void 0 ? [] : _ref2$exclude;
  var fieldsNames = _lodash.default.filter(addressOfStoreFieldsNames, function (item) {
    return !_lodash.default.includes(exclude, item);
  });
  return _lodash.default.assign.apply(_lodash.default, _toConsumableArray(_lodash.default.map(fieldsNames, function (key) {
    return _defineProperty({}, key, _lodash.default.get(store, _lodash.default.replace(key, '-', '.'), ''));
  })));
};
exports.setInitialAddressOfStoreValues = setInitialAddressOfStoreValues;
function AddressOfStoreFields(props) {
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    initialValues = _useFormikContext.initialValues;
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref4) {
      var addressReducer = _ref4.addressReducer;
      return _lodash.default.pick(addressReducer, ['countries', 'states', 'cities']);
    }),
    countries = _useSelector.countries,
    states = _useSelector.states,
    cities = _useSelector.cities;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (!Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS)) {
      if (countries && _lodash.default.isEmpty(countries)) {
        dispatch({
          type: 'FETCH_COUNTRIES'
        });
      }
      if (values['address-country']) {
        dispatch({
          type: 'FETCH_STATES',
          params: {
            'country.id': values['address-country']
          }
        });
      }
      if (values['address-state']) {
        dispatch({
          type: 'FETCH_CITIES',
          params: {
            'state.id': values['address-state']
          }
        });
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    // check if the country is changed and load states of country
    if (!Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS)) {
      // remove the values of all fields related to a country
      setFieldValue('address-state', undefined);
      setFieldValue('address-city', undefined);
      setFieldValue('address-address_01', '');
      dispatch({
        type: 'CLEAN_CITIES'
      });
      dispatch({
        type: 'CLEAN_STATES'
      });
      // get the states of selected country
      dispatch({
        type: 'FETCH_STATES',
        params: {
          'country.id': values['address-country']
        }
      });
    }
  }, [values['address-country']]);
  (0, _react.useEffect)(function () {
    // check if the country is changed and load states of country
    if (!Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS) && !_lodash.default.isEmpty(values['address-state'])) {
      // remove values of all fields related to a state
      setFieldValue('address-city', undefined);
      setFieldValue('address-address_01', '');
      dispatch({
        type: 'CLEAN_CITIES'
      });
      // get the cities of selelcted state
      dispatch({
        type: 'FETCH_CITIES',
        params: {
          'state.id': values['address-state']
        }
      });
    }
  }, [values['address-state']]);
  var useGoogle = Boolean(_config.USE_GOOGLE_PLACES_FOR_ADDRESS);
  var unusedFields = props.unusedFields || _config.UNUSED_FIELDS_IN_STORE_UPDATE.split(",") || [];
  var useMap = Boolean(_config.USE_MAP_FOR_ADDRESS);
  var addressFieldsWidth = unusedFields.some(function (field) {
    return ['state', 'country', 'city'].includes(field);
  }) ? 4 : 6;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.AddressAutocomplete, {
    fullWidth: true,
    required: true,
    label: "Address",
    name: "address-address_01",
    validate: (0, _formValidators.required)(),
    updateAfterTyping: true
  })), !_lodash.default.includes(unusedFields, 'address_02') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    name: "address-address_02",
    label: "Compl\xE9ment d'adresse",
    type: "text",
    margin: "normal",
    fullWidth: true,
    multiline: true
  })), !Boolean(_config.HIDE_CITY_STATE_COUNTRY_FIELDS) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, !_lodash.default.includes(unusedFields, 'country') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: addressFieldsWidth
  }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
    variant: "outlined",
    fullWidth: true,
    required: true,
    label: "Pays",
    name: "address-country",
    margin: "normal",
    validate: (0, _formValidators.required)()
  }, countries && countries.map(function (country) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: country.id,
      value: country.id
    }, country.name);
  })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    name: "address-country",
    label: "Pays",
    type: "text",
    margin: "normal",
    fullWidth: true,
    multiline: true,
    validate: (0, _formValidators.required)(),
    required: true
  })), !_lodash.default.includes(unusedFields, 'state') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: addressFieldsWidth
  }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
    variant: "outlined",
    fullWidth: true,
    required: true,
    label: "D\xE9partement",
    name: "address-state",
    margin: "normal",
    validate: (0, _formValidators.required)()
  }, states && states.map(function (state) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: state.id,
      value: state.id
    }, state.name);
  })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    name: "address-state",
    label: "D\xE9partement",
    type: "text",
    margin: "normal",
    fullWidth: true,
    multiline: true,
    validate: (0, _formValidators.required)(),
    required: true
  })), !_lodash.default.includes(unusedFields, 'city') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: addressFieldsWidth + 1
  }, !useGoogle ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
    variant: "outlined",
    fullWidth: true,
    required: true,
    label: "Commune",
    name: "address-city",
    margin: "normal",
    validate: (0, _formValidators.required)()
  }, cities && cities.map(function (city) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: city.id,
      value: city.id
    }, city.name);
  })) : /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    name: "address-city",
    label: "Commune",
    type: "text",
    margin: "normal",
    fullWidth: true,
    multiline: true,
    validate: (0, _formValidators.required)(),
    required: true
  })), !_lodash.default.includes(unusedFields, 'zipcode') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: addressFieldsWidth - 1
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address-zipcode",
    label: 'Code postal',
    margin: "normal",
    fullWidth: true,
    validate: (0, _formValidators.required)(),
    required: true
  })), !useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address-address_01",
    label: "Address",
    type: "text",
    margin: "normal",
    fullWidth: true,
    multiline: true,
    rows: "3",
    validate: (0, _formValidators.required)(),
    required: true
  })))), useMap && useGoogle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_formFields.LocationPicker, {
    values: values,
    setFieldValue: setFieldValue,
    countries: countries,
    initialValues: initialValues,
    dispatch: dispatch
  })));
}
var _default = AddressOfStoreFields;
exports.default = _default;